import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { logout } from '../../store/authSlice';
import { Container, TextField, Button, Box, Typography, Alert, Link } from '@mui/material';
import api from '../../utils/axiosConfig';
import { toast } from 'react-toastify';


const ForgotPassword = () => {
    const [username, setUsername] = useState('');
    const [error, setError] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const body = { username };
            const response = await api.post(`/api/forgotPassword/email`, body);
            setError('');
            const data = response.data;
            const { success } = data;
            if (success) {
                toast.success('Password reset email sent successfully!');
                dispatch(logout());
                navigate('/login');
            } else {
                setError('Invalid response. Please try again.');
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setError('Incorrect username or password.');
            } else if (error.response && error.response.status === 500) {
                setError('Server error. Please try again later.');
            } else {
                setError('An unexpected error occurred. Please try again.');
            }
        }
    };

    return (
        <Container maxWidth="xs">
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                minHeight="100vh"
            >
                <Typography variant="h4" component="h1" gutterBottom>
                    Send Recovery Email
                </Typography>
                {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>} {/* Display error message */}
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="Email"
                        label="Email"
                        name="Email"
                        autoFocus
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Submit
                    </Button>

                </Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ width: '100%', mt: 1 }}
                >
                    <Link component={RouterLink} to="/login"
                        variant="body2"
                        align="center"
                        sx={{ mt: 1, color: 'text.primary', cursor: 'pointer' }}
                    >
                        Remembered password? Click here
                    </Link>
                </Box>
            </Box>
        </Container>
    );
};

export default ForgotPassword;
